// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function anchor3_viewportEnter(event) {
	//Add your code for this event here: 
let fadeOptions = {
  "duration":   100,
  
};
$w('#Logo').hide("fade",fadeOptions);
$w('#quote').hide("fade",fadeOptions);
}

export function button6_viewportEnter(event) {
	//Add your code for this event here: 
	let fadeOptions = {
  "duration":   200,
  
};
$w('#Logo').show("fade",fadeOptions);	
$w('#quote').show("fade",fadeOptions);	
}